import axiosInstance from "../interceptor/interceptor"; // Assuming axiosInstance is correctly configured
import dictionary from "../dictionary";

const { posts } = dictionary;

const putsService = {
  put: (endpoint: string) => axiosInstance.put(endpoint),
};

export default putsService;